import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkEnable, fetchNotification } from '../api/repository';
import FloatingButton from './Components/FloatingButton.jsx';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [showWarningPopup, setShowWarningPopup] = useState(false);

  useEffect(() => {
    fetchNotification().then(({ show, message }) => {
      if (show) {
        setPopupText(message);
        setShowPopup(true);
      }
    });
  }, []);

  const goProcess = async () => {
    if (isLoading) { return }

    if (window.__showKakaoIOSOverlay) {
      window.__showKakaoIOSOverlay();
      return;
    }

    setIsLoading(true)
    const result = await checkEnable();
    setIsLoading(false)

    if (result.success) {
      navigate('/progress');
    } else {
      setPopupText(result.message);
      setShowPopup(true);
    }
  };

  return (
    <div className="home-page">
      {/* ── 헤더 ── */}
      <div className="logo-row">
        <img src="assets/logo.png" alt="세일택스 로고" className="logo-image" />
      </div>
    <div className="home-wrapper">
      <FloatingButton/>

      {/* ── 히어로 ── */}
      <div className="home-hero">

        <div className="home-content">
          <div className="home-eyebrow">SEIL Tax &amp; Accounting Corporation</div>

          <div className="home-title">
            한 번의 클릭으로<br />편리하고 쉬운 수임동의
          </div>

          <div className="home-divider" />

          <div className="home-subtitle">
            <strong>세무의 모든 순간, 최고의 절세 파트너 세일택스</strong><br/>
            신뢰와 전문성으로 고객 맞춤형 세무 솔루션을 제공합니다.
          </div>

          <button className="home-button" onClick={goProcess}>
            {isLoading ? "확인 중..." : "수임 동의하러 가기"}
          </button>
        </div>

      </div>

      {/* ── 팝업 ── */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p style={{ whiteSpace: "pre-wrap" }}>{popupText}</p>
            <div style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}>
              <button onClick={() => setShowPopup(false)} className="popup-button confirm">
                확인
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── 긴급 공지 팝업 ── */}
      {showWarningPopup && (
        <div className="popup-overlay" onClick={() => setShowWarningPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()} style={{ position: "relative" }}>
            <button
              onClick={() => setShowWarningPopup(false)}
              style={{ position: "absolute", top: 10, right: 10, background: "transparent", border: "none", fontSize: 28, cursor: "pointer", color: "var(--color-muted)" }}
              aria-label="닫기"
            >×</button>
            <p style={{ whiteSpace: "pre-wrap", lineHeight: 1.8 }}>
              <strong>🔔 긴급 안내</strong><br/><br/>
              현재 홈택스 서버 상태가 불안정하여<br/>수임동의 진행이 일시적으로 어려운 상황이에요 😥<br/><br/>
              불편을 드려 정말 죄송합니다.<br/>아래 카카오톡으로 <strong>성함과 연락처</strong>를<br/>남겨주시면 빠르게 개별 안내 드리겠습니다! 🙏
            </p>
            <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
              <button
                onClick={() => { setShowWarningPopup(false); window.open("http://pf.kakao.com/_GCiexb/chat", "_blank"); }}
                className="popup-button kakao"
              >
                <img src="assets/kakaotalk.png" alt="카카오톡" width={17} height={17} style={{ marginRight: 6 }} />
                신고상담
              </button>
            </div>
          </div>
        </div>
      )}
    </div>

      {/* ── 푸터 ── */}
      <div className="home-footer">
        <div className="home-footer-inner">
          <img src="assets/logo.png" alt="세일택스 로고" className="home-footer-logo" />
          <div className="home-footer-info">
            Tel. 02-6953-3971&nbsp;&nbsp;|&nbsp;&nbsp;
            E-mail : info@wtoptax.com&nbsp;&nbsp;|&nbsp;&nbsp;
            서울특별시 강남구 테헤란로 8길 33 2층(청원빌딩)&nbsp;&nbsp;|&nbsp;&nbsp;
            419-81-03476
          </div>
          <div className="home-footer-copy">
            Copyright(C) 2022 세무법인 세일택스 All Right Reserved.&nbsp;&nbsp;
            <a href="https://seiltax.notion.site/1d832c22e04f805392bfcbeea92dee45?pvs=4" className="footer-terms-link" target="_blank" rel="noopener noreferrer">
              이용약관
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
